import SVGIconWrapper from "./SVGIconWrapper"

const IconChat = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 223.23 189.19"
        iconClass={`icon--chat ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M34.61 189.19a5 5 0 0 1-5-5v-38.43H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h213.23a5 5 0 0 1 5 5v135.76a5 5 0 0 1-5 5H79.17l-41 41.92a5 5 0 0 1-3.56 1.51zM10 135.76h24.62a5 5 0 0 1 5 5v31.16l33.87-34.65a5 5 0 0 1 3.58-1.5h136.16V10H10z" /><circle cx="65.14" cy="70.1" r="12.24" /><circle cx="111.61" cy="70.1" r="12.24" /><circle cx="158.09" cy="70.1" r="12.24" />
    </SVGIconWrapper>
)

export default IconChat